import { phoneRegex } from './regex';

export const hidePhoneNumber = message => message.replace(phoneRegex, '(conteudo bloqueado)');

export const hasBlockedContent = message => phoneRegex.test(message);
